/* global Lenis, anime */

// ── Debug flag: set to false to disable Lenis smooth scroll ─────────────────
var USE_LENIS = true;

// Shared Lenis instance — created in the parallax block, used by intro block
var _lenis = null;

// All per-frame scroll handlers registered here; fired by one consolidated Lenis listener
var _scrollHandlers = [];

// Tear down any Lenis instance + raf loop left alive by a previous run of this
// script. The live handle is persisted on `window` (module-level vars reset on
// re-run, e.g. a Shopify section reload in the theme editor), so this is the
// only place able to reach the previous instance and stop it before we re-init.
function _teardownPantoneLenis() {
  var prev = window.__pantoneLenis;
  if (prev) {
    if (prev.rafId) cancelAnimationFrame(prev.rafId);
    if (prev.lenis) {
      try {
        prev.lenis.destroy();
      } catch (e) {
        /* Lenis may already be gone */
      }
    }
    window.__pantoneLenis = null;
  }
  _lenis = null;
  _scrollHandlers.length = 0;
}

// This section's root <section class="shopify-section" id="shopify-section-…">,
// used to scope the unload teardown to *this* section only.
var _pantoneRootEl = document.querySelector('.pantone-lp, .pantone__banner');
var _pantoneRoot = _pantoneRootEl ? _pantoneRootEl.closest('.shopify-section') : null;

// Guard against double init: stop a stale instance before this run starts.
_teardownPantoneLenis();

// ── Banner parallax ───────────────────────────────────────────────────────────
(function () {
  'use strict';

  var bannerBg = document.querySelector('.pantone__banner-bg');
  var bannerSection = document.querySelector('.pantone__banner');

  if (!bannerBg || !bannerSection) return;

  var bannerTop = 0,
    bannerBottom = 0;
  function cacheBannerLayout() {
    bannerTop = bannerSection.getBoundingClientRect().top + window.pageYOffset;
    bannerBottom = bannerTop + bannerSection.offsetHeight;
  }
  cacheBannerLayout();
  window.addEventListener('resize', cacheBannerLayout, { passive: true });

  function applyParallax(scrollY) {
    if (scrollY > bannerBottom || scrollY + window.innerHeight < bannerTop) return;
    bannerBg.style.transform = 'translateY(' + scrollY * 0.1 + 'px)';
  }

  if (USE_LENIS) {
    _lenis = new Lenis();
    // Persist the live instance + raf id so a later run can tear this down.
    var _handle = (window.__pantoneLenis = { lenis: _lenis, rafId: 0 });
    _scrollHandlers.push(function (e) {
      applyParallax(e.scroll);
    });
    function raf(time) {
      _lenis.raf(time);
      _handle.rafId = requestAnimationFrame(raf);
    }
    _handle.rafId = requestAnimationFrame(raf);
  } else {
    var targetY = 0,
      smoothY = 0;
    window.addEventListener(
      'scroll',
      function () {
        targetY = window.scrollY;
      },
      { passive: true }
    );
    function rafNative() {
      smoothY += (targetY - smoothY) * 0.1;
      applyParallax(smoothY);
      requestAnimationFrame(rafNative);
    }
    requestAnimationFrame(rafNative);
  }
})();

// ── Banner mute toggle ───────────────────────────────────────────────────────
(function () {
  'use strict';

  var btn = document.querySelector('.pantone__banner-mute');
  var video = document.getElementById('pantone-banner-video');
  if (!btn || !video) return;

  btn.addEventListener('click', function () {
    video.muted = !video.muted;
    var unmuted = !video.muted;
    btn.setAttribute('aria-pressed', unmuted ? 'true' : 'false');
    btn.setAttribute('aria-label', unmuted ? 'Mute video' : 'Unmute video');
  });
})();

// ── Banner intro on-load fade-ins ────────────────────────────────────────────
(function () {
  'use strict';

  var introBanner = document.querySelector('.pantone__banner--intro');
  if (!introBanner) return;

  var headline = introBanner.querySelector('.pantone__banner-headline');
  var bottom = introBanner.querySelector('.pantone__banner-bottom');

  if (headline) anime.set(headline, { opacity: 0 });
  if (bottom) anime.set(bottom, { opacity: 0 });

  if (headline) anime({ targets: headline, opacity: [0, 1], duration: 900, easing: 'easeOutQuart', delay: 1800 });
  if (bottom) anime({ targets: bottom, opacity: [0, 1], duration: 900, easing: 'easeOutQuart', delay: 1800 });
})();

// ── Intro animations + image col parallax ────────────────────────────────────
(function () {
  'use strict';

  var introSection = document.querySelector('.pantone__intro');
  var headlineLines = document.querySelectorAll('.pantone__intro-headline__line');
  var imgColLeft = document.querySelector('.pantone__intro-img-col--left');
  var imgColRight = document.querySelector('.pantone__intro-img-col--right');
  var cta = document.querySelector('.pantone__intro-cta');
  var body = document.querySelector('.pantone__intro-body');

  if (introSection && headlineLines.length) {
    anime.set(headlineLines, { translateY: '105%' });
    if (imgColLeft) anime.set(imgColLeft, { opacity: 0, translateY: 40 });
    if (imgColRight) anime.set(imgColRight, { opacity: 0, translateY: 40 });
    if (cta) anime.set(cta, { opacity: 0, translateY: 40 });
    if (body) anime.set(body, { opacity: 0, translateY: 40 });

    var scrollYAtTriggerLeft = 0,
      parallaxReadyLeft = false;
    var scrollYAtTriggerRight = 0,
      parallaxReadyRight = false;

    var introObserver = new IntersectionObserver(
      function (entries) {
        if (!entries[0].isIntersecting) return;
        introObserver.disconnect();

        var EASE = 'easeOutQuart';
        var DUR = 900;
        var isMobile = window.innerWidth < 768;

        // On mobile the images sit below the headline, so delay them until after headlines finish
        var imgDelay = isMobile ? 850 : 100;

        if (imgColLeft) {
          anime({
            targets: imgColLeft,
            opacity: [0, 1],
            translateY: [40, 0],
            scale: [0.9, 1],
            duration: DUR,
            easing: EASE,
            delay: imgDelay,
            complete: function () {
              scrollYAtTriggerLeft = _lenis ? _lenis.scroll : window.scrollY;
              parallaxReadyLeft = true;
            },
          });
        } else {
          parallaxReadyLeft = true;
        }

        anime({
          targets: headlineLines,
          translateY: ['105%', '0%'],
          duration: 700,
          easing: 'easeOutQuart',
          delay: anime.stagger(150, { start: 220 }),
        });

        if (imgColRight) {
          anime({
            targets: imgColRight,
            opacity: [0, 1],
            translateY: [40, 0],
            scale: [0.9, 1],
            duration: DUR,
            easing: EASE,
            delay: isMobile ? imgDelay + 150 : 100,
            complete: function () {
              scrollYAtTriggerRight = _lenis ? _lenis.scroll : window.scrollY;
              parallaxReadyRight = true;
            },
          });
        } else {
          parallaxReadyRight = true;
        }

        if (cta) {
          anime({
            targets: cta,
            opacity: [0, 1],
            translateY: [40, 0],
            scale: [0.8, 1],
            duration: DUR,
            easing: EASE,
            delay: 1100,
          });
        }

        if (body) {
          anime({ targets: body, opacity: [0, 1], translateY: [40, 0], duration: 1200, easing: EASE, delay: 1600 });
        }
      },
      { threshold: 0.4 }
    );

    introObserver.observe(introSection);
  }

  // Image col parallax — targets the outer col elements after anime.js has finished.
  // Images move faster than surrounding content (closer plane effect).
  // e.scroll from Lenis gives the smoothed scroll position on every RAF tick.
  // ── Parallax speed controls ───────────────────────────────────────────────
  // Negative = moves up faster than content (closer plane). 0 = no parallax.
  var PARALLAX_LEFT = -0.15;
  var PARALLAX_RIGHT = -0.1;
  // ─────────────────────────────────────────────────────────────────────────

  function updateImgParallax(e) {
    if (window.innerWidth < 768) return;
    var scrollY = e ? e.scroll : window.scrollY;
    if (parallaxReadyLeft && imgColLeft) {
      var deltaLeft = scrollY - scrollYAtTriggerLeft;
      if (deltaLeft > 0) imgColLeft.style.transform = 'translateY(' + deltaLeft * PARALLAX_LEFT + 'px)';
    }
    if (parallaxReadyRight && imgColRight) {
      var deltaRight = scrollY - scrollYAtTriggerRight;
      if (deltaRight > 0) imgColRight.style.transform = 'translateY(' + deltaRight * PARALLAX_RIGHT + 'px)';
    }
  }

  if (_lenis) {
    _scrollHandlers.push(updateImgParallax);
  } else {
    window.addEventListener(
      'scroll',
      function () {
        updateImgParallax(null);
      },
      { passive: true }
    );
  }
})();

// ── Designed section sticky scroll ───────────────────────────────────────────
(function () {
  'use strict';

  var section = document.querySelector('.pantone__designed');
  var inner = document.querySelector('.pantone__designed-inner');
  var bg = document.querySelector('.pantone__designed-bg');
  var textLeft = document.querySelector('.pantone__designed-text--left');
  var textRight = document.querySelector('.pantone__designed-text--right');
  var logos = document.querySelector('.pantone__designed-logos');

  if (!section || !bg) return;

  // Entry animation range: scale 0.8→1 + translateY 60→0 over the first half-viewport of scroll
  var ENTRY_RANGE_PX = window.innerHeight * 0.5;
  var ENTRY_SCALE_FROM = 0.8;
  var ENTRY_TRANSLATE_FROM = 160; // px

  // Fraction of scroll progress over which texts converge to final position (0.0 → 0.8 = first 80%)
  var TEXT_ANIM_WINDOW = 0.8;
  // BG parallax: how many px it drifts upward over the full scroll window
  var BG_PARALLAX_PX = 0;

  // Per-element start offset: push each text to the viewport bottom regardless of its CSS `top` value.
  // offsetTop gives the natural position from the sticky container top (= CSS top% resolved in px).
  var startLeft = textLeft ? window.innerHeight * 0.8 - textLeft.offsetTop : 0;
  var startRight = textRight ? window.innerHeight * 0.8 - textRight.offsetTop : 0;
  // Logos preserve their natural y-gap from the text elements
  var startLogos = logos && textLeft ? startLeft + (logos.offsetTop - textLeft.offsetTop) : 0;

  var sectionTop = 0,
    scrollWindow = 0,
    entryScroll = 0,
    totalRange = 0;
  function cacheDesignedLayout() {
    sectionTop = section.getBoundingClientRect().top + window.pageYOffset;
    scrollWindow = section.offsetHeight - window.innerHeight;
    entryScroll = sectionTop - window.innerHeight;
    totalRange = section.offsetHeight + window.innerHeight;
  }
  cacheDesignedLayout();
  window.addEventListener('resize', cacheDesignedLayout, { passive: true });

  function update(scrollY) {
    // Entry animation runs regardless of scroll window (doesn't need sticky dwell range)
    if (inner) {
      var entryProgress = Math.max(0, Math.min(1, (scrollY - entryScroll) / ENTRY_RANGE_PX));
      var entryScale = ENTRY_SCALE_FROM + entryProgress * (1 - ENTRY_SCALE_FROM);
      var entryTranslateY = ENTRY_TRANSLATE_FROM * (1 - entryProgress);
      inner.style.transform = 'translateY(' + entryTranslateY + 'px) scale(' + entryScale + ')';
    }

    if (scrollWindow <= 0) return;

    var bgProgress = Math.max(0, Math.min(1, (scrollY - entryScroll) / totalRange));
    var bgScale = 1 + bgProgress * 0.2;
    bg.style.transform = 'translateY(' + bgProgress * -BG_PARALLAX_PX + 'px) scale(' + bgScale + ')';

    var textRange = window.innerHeight + scrollWindow * TEXT_ANIM_WINDOW;
    var animProgress = Math.max(0, Math.min(1, (scrollY - entryScroll) / textRange));
    var factorLeft = (1 - animProgress) * startLeft;
    var factorRight = (1 - animProgress) * startRight;
    var factorLogos = (1 - animProgress) * startLogos;

    if (textLeft) textLeft.style.transform = 'translateY(calc(-50% + ' + factorLeft + 'px))';
    if (textRight) textRight.style.transform = 'translateY(calc(-50% + ' + factorRight + 'px))';
    if (logos) logos.style.transform = 'translateX(-50%) translateY(' + factorLogos + 'px)';
  }

  // Set initial state — texts start at viewport bottom (only when there is scroll room to animate)
  if (scrollWindow > 0) {
    if (textLeft) textLeft.style.transform = 'translateY(calc(-50% + ' + startLeft + 'px))';
    if (textRight) textRight.style.transform = 'translateY(calc(-50% + ' + startRight + 'px))';
  }
  bg.style.transform = 'translateY(0px) scale(1)';
  if (inner) inner.style.transform = 'translateY(' + ENTRY_TRANSLATE_FROM + 'px) scale(' + ENTRY_SCALE_FROM + ')';
  update(_lenis ? _lenis.scroll : window.scrollY);

  if (_lenis) {
    _scrollHandlers.push(function (e) {
      update(e.scroll);
    });
  } else {
    window.addEventListener(
      'scroll',
      function () {
        update(window.scrollY);
      },
      { passive: true }
    );
  }
})();

// ── Boundary dwell: pantone__designed → pantone__accordion ───────────────────
(function () {
  'use strict';

  if (!_lenis) return;
  if (window.innerWidth < 768) return;

  var LOCK_DURATION = 650;

  function makeBoundaryDwell(selector) {
    var el = document.querySelector(selector);
    if (!el) return;

    var boundaryY = el.getBoundingClientRect().top + window.pageYOffset;
    var fired = false;

    _scrollHandlers.push(function (e) {
      if (e.scroll < boundaryY - 20) {
        fired = false;
        return;
      }
      if (fired || e.scroll < boundaryY) return;

      fired = true;
      _lenis.stop();

      setTimeout(function () {
        _lenis.scrollTo(_lenis.scroll, { immediate: true });
        _lenis.start();
      }, LOCK_DURATION);
    });
  }

  makeBoundaryDwell('.pantone__intro');
  makeBoundaryDwell('.pantone__accordion');
})();


// ── Consolidated Lenis scroll dispatcher ─────────────────────────────────────
// Single listener replaces all individual _lenis.on('scroll', ...) calls above.
if (_lenis) {
  _lenis.on('scroll', function (e) {
    for (var i = 0; i < _scrollHandlers.length; i++) {
      _scrollHandlers[i](e);
    }
  });
}

// Teardown-safe: when Shopify unloads/reloads THIS section in the theme editor,
// cancel the raf loop, destroy the Lenis instance and clear handlers so the next
// run starts clean instead of stacking a second instance + raf loop. Scoped by
// section id — unloading an unrelated section must not tear us down, since this
// script only re-runs (and re-inits) when the pantone section itself reloads.
function _onPantoneSectionUnload(e) {
  if (!e || !e.detail) return;
  if (_pantoneRoot && _pantoneRoot.id !== 'shopify-section-' + e.detail.sectionId) return;
  _teardownPantoneLenis();
}
// Remove the previous run's listener so it doesn't accumulate on re-execution.
if (window.__pantoneUnloadHandler) {
  window.removeEventListener('shopify:section:unload', window.__pantoneUnloadHandler);
}
window.__pantoneUnloadHandler = _onPantoneSectionUnload;
window.addEventListener('shopify:section:unload', _onPantoneSectionUnload);

// ── Accordion ─────────────────────────────────────────────────────────────────
(function () {
  'use strict';

  var items = document.querySelectorAll('.pantone__accordion-item');

  var panelImgs = document.querySelectorAll('.pantone__accordion-right-img');
  var imgBase = panelImgs[0];
  var imgTop = panelImgs[1];

  var overlayImgs = document.querySelectorAll('.pantone__accordion-overlay');
  var overlayBase = overlayImgs[0];
  var overlayTop = overlayImgs[1];

  function applyOverlayWidth(el, width) {
    if (!el) return;
    el.style.width = width || '';
  }

  var activeOnLoad = document.querySelector('.pantone__accordion-item--active');
  if (activeOnLoad && activeOnLoad.dataset.panelOverlay && overlayBase) {
    overlayBase.src = activeOnLoad.dataset.panelOverlay;
    applyOverlayWidth(overlayBase, activeOnLoad.dataset.panelOverlayWidth);
    applyOverlayWidth(overlayTop, activeOnLoad.dataset.panelOverlayWidth);
    anime.set(overlayBase, { opacity: 1 });
  }

  items.forEach(function (item) {
    var trigger = item.querySelector('.pantone__accordion-trigger');
    if (!trigger) return;

    trigger.addEventListener('click', function () {
      if (item.classList.contains('pantone__accordion-item--active')) return;

      items.forEach(function (i) {
        i.classList.remove('pantone__accordion-item--active');
        var t = i.querySelector('.pantone__accordion-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });

      item.classList.add('pantone__accordion-item--active');
      trigger.setAttribute('aria-expanded', 'true');

      if (!imgBase || !imgTop) return;

      // Cancel any in-flight animations before starting new ones.
      // If imgTop was mid-transition (opacity > 0), commit it as the new base
      // so the next crossfade doesn't show the same image on both layers.
      anime.remove([imgBase, imgTop, overlayBase, overlayTop].filter(Boolean));
      if (imgTop && imgTop.src && parseFloat(imgTop.style.opacity) > 0) {
        imgBase.src = imgTop.src;

        if (overlayBase && overlayTop && overlayTop.src) {
          overlayBase.src = overlayTop.src;
          if (overlayTop.style.width) overlayBase.style.width = overlayTop.style.width;
          anime.set(overlayBase, { opacity: 1 });
        }
      }
      anime.set(imgTop, { opacity: 0 });
      if (overlayTop) anime.set(overlayTop, { opacity: 0 });

      var newImgSrc = item.dataset.panelImage || '';
      var newOverlaySrc = item.dataset.panelOverlay || '';
      var newOverlayWidth = item.dataset.panelOverlayWidth || '';
      imgTop.src = newImgSrc;
      if (overlayTop) {
        overlayTop.src = newOverlaySrc;
        applyOverlayWidth(overlayTop, newOverlayWidth);
      }

      if (overlayBase && overlayTop) {
        anime({ targets: overlayBase, opacity: 0, duration: 600, easing: 'easeInOutQuad' });
      }

      if (overlayTop && newOverlaySrc) {
        anime({ targets: overlayTop, opacity: [0, 1], duration: 600, easing: 'easeInOutQuad' });
      }

      anime({
        targets: imgTop,
        opacity: [0, 1],
        duration: 1500,
        easing: 'easeOutQuart',
        complete: function () {
          imgBase.src = newImgSrc;
          anime.set(imgTop, { opacity: 0 });

          if (overlayBase && overlayTop) {
            overlayBase.src = newOverlaySrc;
            applyOverlayWidth(overlayBase, newOverlayWidth);
            anime.set(overlayBase, { opacity: newOverlaySrc ? 1 : 0 });
            overlayTop.src = '';
            anime.set(overlayTop, { opacity: 0 });
          }
        },
      });
    });
  });
})();

// ── Collection cards fade-up ──────────────────────────────────────────────────
(function () {
  'use strict';

  var cards = document.querySelectorAll('.pantone__collection-card');
  if (!cards.length) return;

  anime.set(cards, { opacity: 0, translateY: 40, scale: 0.8 });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var index = Array.prototype.indexOf.call(cards, entry.target);
        anime({
          targets: entry.target,
          opacity: [0, 1],
          translateY: [40, 0],
          scale: [0.9, 1],
          duration: 600,
          easing: 'easeOutQuart',
          delay: 100 + index * 80,
        });
      });
    },
    { threshold: 0.15 }
  );

  cards.forEach(function (card) {
    observer.observe(card);
  });
})();

// ── Collection CTA headline slide-up + CTA fade-in ────────────────────────────
(function () {
  'use strict';

  var lines = document.querySelectorAll('.pantone__collection-cta-headline__line');
  var btn = document.querySelector('.pantone__collection-cta-btn');
  var cta = document.querySelector('.pantone__collection-cta');

  if (!cta || !lines.length) return;

  anime.set(lines, { translateY: '105%' });
  if (btn) anime.set(btn, { opacity: 0, translateY: 20 });

  var observer = new IntersectionObserver(
    function (entries) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();

      anime({
        targets: lines,
        translateY: ['105%', '0%'],
        duration: 700,
        easing: 'easeOutQuart',
        delay: anime.stagger(130, { start: 200 }),
      });

      if (btn) {
        anime({
          targets: btn,
          opacity: [0, 1],
          translateY: [20, 0],
          duration: 700,
          easing: 'easeOutQuart',
          delay: 200 + lines.length * 130 + 100,
        });
      }
    },
    { threshold: 0.3 }
  );

  observer.observe(cta);
})();
